/* eslint-disable import/no-default-export */
import * as React from 'react';

import { IStyleConfig, mergeStyles } from '@cian/utils';

import * as styles from './dropdown_field.css';
import {
  Button,
  ButtonTheme,
  ButtonThemeType,
  DropdownFieldPopupContent,
  IDropdownValue,
  PopupArrow,
  Popup,
} from '@cian/components';
import { AbstractDropdown, IAbstractDropdownProps, IAbstractDropdownState } from '../dropdown/dropdown';

export interface IDropdownFieldProps extends IAbstractDropdownProps {
  buttonStyle?: IStyleConfig;
  theme?: ButtonThemeType;
  dataMark?: string;
}

export default class DropdownField extends AbstractDropdown<IDropdownFieldProps, IAbstractDropdownState, Button> {
  public static defaultProps = {
    theme: ButtonTheme.TOGGLE,
    multiple: false,
  };

  public renderButton(selectedLabel: string | JSX.Element): JSX.Element {
    return (
      <Button
        ref={(button: Button) => (this.button = button)}
        theme={this.state.opened ? ButtonTheme.TOGGLE_ACTIVE : this.props.theme}
        buttonStyle={mergeStyles(
          styles['button'],
          this.state.opened && styles['button--opened'],
          this.props.invalid && styles['button--invalid'],
          this.props.buttonStyle,
        )}
        onClick={() => this.toggleOpened()}
        onKeyDown={event => this.handleKeyDown(event)}
        dataMark={this.props.dataMark}
      >
        {this.props.label || selectedLabel}
      </Button>
    );
  }

  public renderPopup({
    activeValue,
    selectedValue,
  }: {
    activeValue: IDropdownValue[];
    selectedValue: IDropdownValue[];
  }): JSX.Element {
    return (
      <Popup
        arrow={PopupArrow.LEFT}
        containerStyle={[
          {
            marginTop: 13,
          },
          this.props.popupStyle,
        ]}
      >
        <DropdownFieldPopupContent
          multiple={this.props.multiple}
          containerStyle={this.props.popupContentStyle}
          valueStyle={this.props.valueStyle}
          valueActiveStyle={this.props.valueActiveStyle}
          valueSelectedStyle={this.props.valueSelectedStyle}
          ref={popupContent => (this.popupContent = popupContent)}
          value={activeValue}
          values={this.props.values}
          selectedValue={selectedValue}
          onValueClick={(value: IDropdownValue) => this.handleValueClick(value)}
          onValueMouseOver={(value: IDropdownValue) => this.handleValueMouseOver(value)}
        />
      </Popup>
    );
  }
}
